import { render, staticRenderFns } from "./form_detail_component.vue?vue&type=template&id=df1c7822&scoped=true"
import script from "./form_detail_component.vue?vue&type=script&lang=js"
export * from "./form_detail_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_component.vue?vue&type=style&index=0&id=df1c7822&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1c7822",
  null
  
)

export default component.exports